import common from "../../utill/Common";

class ReportsService {
  xlsCommissionBalance = async (token) => {
    const url = common.baseUrl + "admin/reports/xls_commission_balance";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: null,
    };

    const response = await fetch(url, options);

    return response.json();
  };

  activityLogs = async (
    token,
    from_date,
    to_date,
    search_text,
    user_id,
    page,
    size
  ) => {
    const url = common.baseUrl + "admin/reports/activity_logs";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({
        from_date,
        to_date,
        search_text,
        user_id,
        page,
        size,
      }),
    };

    const response = await fetch(url, options);

    return response.json();
  };
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new ReportsService();
